import type { AalView } from "../aalV2";
import { useAalListQuery } from "../aalV2";

export type WithdrawalsAALTableFilters = {
  view: AalView;
  start_date: string;
  end_date: string;
  page?: number;
  size?: number;
  sort?: string;
  agent_id?: string;
  agent_role_id?: string;
  username?: string;
  payment_gateway?: string;
  payment_method?: string;
  status?: string;
  subregion?: string;
};

export type WithdrawalsAALTableItem = Record<string, unknown>;

export const useGetAALWithdrawalsTable = (
  filters: WithdrawalsAALTableFilters,
) => {
  const {
    view,
    start_date,
    end_date,
    page,
    size,
    sort,
    agent_id,
    agent_role_id,
    username,
    payment_gateway,
    payment_method,
    status,
    subregion,
  } = filters;

  return useAalListQuery<WithdrawalsAALTableItem>("withdrawals", view, {
    start_date,
    end_date,
    page,
    size,
    sort,
    filters: {
      agent_id,
      agent_role_id,
      username,
      payment_gateway,
      payment_method,
      status,
      subregion,
    },
  });
};
